import * as THREE from 'three'
require('three-orbitcontrols');

export var scene;//相机
export var camera;//场景
export var renderer;//渲染器
export let currentMesh;
export let controls;

let renderCount = -1;


// -1标识一直渲染
// 0标识不渲染
// 1标识有限次数渲染
export function incRenderCount() {
    renderCount += 2;
}

//创建地板
export function createFloor() {
    let planeGeometry = new THREE.PlaneBufferGeometry(3000, 3000);
    let planeMaterial = new THREE.ShadowMaterial({ color: 0xf2f2f2 });
    let floor = new THREE.Mesh(planeGeometry, planeMaterial);
    floor.rotation.x = -(90 * Math.PI / 180);
    floor.position.y = -62;
    floor.receiveShadow = true;
    scene.add(floor);
    return floor;
};


function createLights() {
    // 添加光源
    let spotLight = new THREE.SpotLight(0xffffff, 0.4);
    spotLight.position.set(-60, 168, -89);
    spotLight.castShadow = true;
    spotLight.shadow.camera.far = 1000; //设置阴影的大小

    //设置阴影分辨率
    spotLight.shadow.mapSize.width = 512;
    spotLight.shadow.mapSize.height = 512;
    scene.add(spotLight);

    // 环境光
    let ambientLight = new THREE.AmbientLight(0xffffff, 0.4);
    scene.add(ambientLight);

    let dirLight4 = new THREE.DirectionalLight(0xffffff, 0.1);
    dirLight4.position.set(0, -130, 0); //注意：位置一定要调整好，否则会出现物体变成黑色的情况
    scene.add(dirLight4);
};

export function initThree(canvas) {
    let canvas_bound = canvas.getBoundingClientRect();
    scene = new THREE.Scene(); //相机

    //创建3D世界
    let w = canvas_bound.width;
    let h = canvas_bound.height;

    //创建渲染器
    renderer = new THREE.WebGLRenderer({
        canvas: canvas,
        antialias: true, //抗锯齿
        preserveDrawingBuffer: true, //3D加上这个在缩略图中可以变成白色
    });
    renderer.setSize(w, h);
    renderer.setPixelRatio(2);

    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    renderer.setClearColor(0xffffff, 1);

    // 创建场景
    // 量纲，单位 1px 1m 1kg
    camera = new THREE.PerspectiveCamera(50, w / h, 0.1, 42000);

    //定义相机的x,y,z位置   9.452431950937196 240.22113583599642 338.8649545584154
    camera.position.set(-581.3320450722096, 119.90585106068511, -7.048044164959875);
    camera.lookAt(scene.position); //把相机的位置渲染到场景中


    //控制器，鼠标左键和右键，滑轮操作
    controls = new THREE.OrbitControls(camera, canvas);

    //是否可以缩放
    controls.enableZoom = true;
    //设置相机距离原点的最远距离
    controls.minDistance = 20;
    controls.maxDistance = 10000;

    let cameraLight = new THREE.DirectionalLight(0xffffff, 0.4);
    cameraLight.position.copy(camera.position);
    scene.add(cameraLight);
    controls.addEventListener("change", function () {
        renderCount += 2;
        cameraLight.position.copy(camera.position);
        // console.log(camera.position.x, camera.position.y, camera.position.z);
    });


    createLights();

    //渲染场景
    function animate(now) {
        requestAnimationFrame(animate);
        if (renderCount > 0) {
            renderer.render(scene, camera);
            renderCount = 0;
        } else if (renderCount < 0) {
            renderCount++;
            renderer.render(scene, camera);
        }
    }
    animate(0);
}


// WEBPACK FOOTER //
// ./src/views/papercutLamp/scripts/initThree.js